<app-page-meta pageTitle="finzy - Loan Application"></app-page-meta>
<div class="row mainrow">
  <form #d="ngForm" (ngSubmit)="submitOtpVerification(d.value)" (keydown.enter)="$event.preventDefault()">
    <p class="heading">We’ll need a phone number to reach you on</p>

    <p class="form-field-heading">Your current mobile number</p>
    <mat-form-field style="width: 100%">
      <span matPrefix class="input-prefix">+91&nbsp;</span>
      <input matInput placeholder="You will need this to login and for updates" [(ngModel)]="phoneNumber"
             [readonly]="isReadonly" maxlength="10" name="phoneno" type="text" class="pt-2px"
             (keyup)="onPhoneInput($event)"
             [disabled]="phoneNumberDisabled">
      <button mat-stroked-button matSuffix (click)="sendOtp(); analyticsTracker.trackButtonClick('Borrower Phone Verification', otpButton);"
              class="hidden-xs btn-input-suffix"
              [disabled]="fieldDisabledTag" type="button">{{otpButton}}
      </button>
      <button mat-stroked-button matSuffix (click)="sendOtp(); analyticsTracker.trackButtonClick('Borrower Phone Verification', otpButton);"
              class="visible-xs-inline-block input-suffix-button-mobile"
              [disabled]="fieldDisabledTag" type="button">{{otpButton}}
      </button>
    </mat-form-field>
    <span class="errormsg" *ngIf="mobileError">{{mobileErrorMsg}}</span>

    <div *ngIf="showOtp">
      <p class="form-field-heading">Enter OTP number</p>
      <mat-form-field style="width: 100%">
        <input matInput placeholder="Please enter the OTP you have received on your phone"
               [(ngModel)]="otp"
               name="otp" required type="password" maxlength="6" [disabled]="otpDisabled">
      </mat-form-field>
      <span class="errormsg2" *ngIf="mobileOtpError">Please provide a valid OTP</span>
    </div>

    <div *ngIf="shouldShowConsentCheckboxes()">
      <section id="checkbox-block">
        <p class="bottom terms-and-conditions-text">
          <mat-checkbox [disabled]="!shouldShowConsentCheckboxes()" [required]="!isLoanAssociated()"
                        name="termsAndConditionsCheck"
                        [(ngModel)]="termsAndConditionsCheck"
                        title="Please accept terms to proceed"></mat-checkbox>&nbsp;&nbsp; I
          agree to the <a [routerLink]="['/terms']" target="_blank" class="terms">Terms and
          conditions</a></p>

        <p class="bottom terms-and-conditions-text">
          <mat-checkbox [disabled]="!shouldShowConsentCheckboxes()" [required]="!isLoanAssociated()"
                        [(ngModel)]="consentForEquifaxCheck"
                        name="consentForEquifaxCheck"
                        title="Please accept terms to proceed"></mat-checkbox>&nbsp;&nbsp; I
          authorise Finzy and its partners to avail my credit information report (CIR) from Equifax
        </p>

        <p class="bottom terms-and-conditions-text">
          <mat-checkbox [required]="!isLoanAssociated()" [disabled]="!shouldShowConsentCheckboxes()"
                        name="borrowedAmountDeclarationCheck"
                        [(ngModel)]="borrowedAmountDeclarationCheck"
                        style="margin-right:5px"></mat-checkbox>
          I, hereby confirm that, the aggregate of all loans taken by me across all the P2P platforms
          in India,
          including the amount requested in this loan application, does not exceed &#8377; 10,00,000
          as on date. I
          undertake to inform Finzy on 9341 300 300, if my aggregate exposure from borrowing at any
          point of time is
          equivalent to &#8377; 10,00,000, and understand and agree that Finzy shall be entitled to
          take any actions
          as it
          may deem fit, if my aggregate exposure, whether as on date or anytime in the future exceeds
          &#8377;
          10,00,000.
        </p>
      </section>
      <span class="errormsg2" *ngIf="checkError">Please accept terms to proceed</span>
    </div>

    <div class="row">
      <div class="col-xs-6">
        <button mat-stroked-button class="button-back primary" *ngIf="disableBtn" type="button" (click)="previousPage()"><i
          class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp; BACK
        </button>
      </div>
      <div class="col-xs-6 moveright">
        <app-forward-button class="button-forward" [isLoading]="loader"
                            (click)="analyticsTracker.trackButtonClick('Borrower Phone Verification', 'NEXT')">NEXT
        </app-forward-button>
      </div>
    </div>
  </form>
</div>
